import React, { useState } from "react";
import "./LoginPage.css";

const LoginPage = () => {
  const [loginData, setLoginData] = useState({
    unitName: "",
    accessCode: "",
    password: "",
  });

  const [registerData, setRegisterData] = useState({
    unitName: "",
    secureEmail: "",
    accessCode: "",
  });

  const handleLoginChange = (e) => {
    setLoginData({
      ...loginData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRegisterChange = (e) => {
    setRegisterData({
      ...registerData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    console.log("Login submitted:", loginData);
  };

  const handleRegisterSubmit = (e) => {
    e.preventDefault();
    console.log("Registration submitted:", registerData);
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-panel">
          <h2>//:OPERATOR_LOGIN</h2>
          <form onSubmit={handleLoginSubmit} className="login-form">
            <div className="form-group">
              <label className="form-label">&gt; UNIT_NAME:</label>
              <input
                type="text"
                name="unitName"
                value={loginData.unitName}
                onChange={handleLoginChange}
                className="form-input"
                placeholder="Enter unit name"
              />
            </div>
            <div className="form-group">
              <label className="form-label">&gt; ACCESS_CODE:</label>
              <input
                type="text"
                name="accessCode"
                value={loginData.accessCode}
                onChange={handleLoginChange}
                className="form-input"
                placeholder="Enter access code"
              />
            </div>
            <div className="form-group">
              <label className="form-label">&gt; PASSWORD:</label>
              <input
                type="password"
                name="password"
                value={loginData.password}
                onChange={handleLoginChange}
                className="form-input"
                placeholder="Enter password"
              />
            </div>
            <button type="submit" className="submit-btn">
              [ AUTHENTICATE_ACCESS ]
            </button>
          </form>
        </div>

        <div className="register-panel">
          <h2>//:ESTABLISH NEW CALLSIGN</h2>
          <form onSubmit={handleRegisterSubmit} className="register-form">
            <div className="form-group">
              <label className="form-label">&gt; UNIT_NAME:</label>
              <input
                type="text"
                name="unitName"
                value={registerData.unitName}
                onChange={handleRegisterChange}
                className="form-input"
                placeholder="Enter unit name"
              />
            </div>
            <div className="form-group">
              <label className="form-label">&gt; SECURE_EMAIL:</label>
              <input
                type="email"
                name="secureEmail"
                value={registerData.secureEmail}
                onChange={handleRegisterChange}
                className="form-input"
                placeholder="Enter secure email"
              />
            </div>
            <div className="form-group">
              <label className="form-label">&gt; ACCESS_CODE:</label>
              <input
                type="text"
                name="accessCode"
                value={registerData.accessCode}
                onChange={handleRegisterChange}
                className="form-input"
                placeholder="Enter access code"
              />
            </div>
            <button type="submit" className="submit-btn">
              [ INITIATE_REGISTRATION ]
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
